var exports = {
  "y": "AutocompleteMention.module__divider___dFFFM2",
};

module.exports = exports;
